export default "<footer class=\"footer fixed-bottom\">\n  <span>Powered by Tiingo. Developed by Ritesh Talreja.</span>\n</footer>";